export default __webpack_public_path__ + "static/meta-928e4e4b42330a6a130db7f69cc5f65e.jpg";